import { render, staticRenderFns } from "./AssetSelect.vue?vue&type=template&id=967eb552&"
import script from "./AssetSelect.vue?vue&type=script&lang=ts&"
export * from "./AssetSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports